import { KoobInputSelect } from '@koob/ui';
import { useAsync } from 'react-async';
import { useLanguage } from 'hooks';
import { getLanguages } from 'api/languages';
import { useState } from 'react';

const defaultLocale = {
  value: 'en',
  label: 'EN',
  alpha2: 'gb',
};

const LocaleSwitcher = ({ queryLocale, disabled, onChange }) => {
  const { data, isLoading } = useAsync({ promiseFn: getLanguages });
  const { updateQueryLocale, lang } = useLanguage();
  const [userSelectedLang, setUserSelectedLang] = useState(null);

  const LanguageCode = {};
  const locales = data?.data?.map(({ name, description }) => {
    LanguageCode[name] = description.toLowerCase();
    return {
      label: name.toUpperCase(),
      value: name,
      alpha2: description.toLowerCase(),
    };
  });

  const effectiveLang = userSelectedLang ?? queryLocale?.value ?? lang;
  const optionSelected = effectiveLang
    ? {
        value: effectiveLang,
        label: effectiveLang.toUpperCase(),
        alpha2: LanguageCode[effectiveLang] || effectiveLang,
      }
    : defaultLocale;

  const selectOptions = locales ?? [optionSelected];

  // Flags are sized explicitly (same as KoobInputCountries rows) — left to
  // the font-size of the trigger they render a few pixels tall.
  const renderLocale = ({ label, alpha2 }) => (
    <div className="flex items-center gap-1.5">
      <span
        className={`flag-icon flag-icon-${alpha2} h-4 w-5 shrink-0 rounded-sm`}
      />
      <span className="whitespace-nowrap">{label}</span>
    </div>
  );

  return (
    <div className="w-36">
      <KoobInputSelect
        options={selectOptions}
        loading={isLoading}
        value={optionSelected?.value}
        onValueChange={v => {
          const value = selectOptions.find(option => option.value === v);
          setUserSelectedLang(value?.value);
          updateQueryLocale(value);
          onChange?.(value);
        }}
        renderValue={renderLocale}
        renderOption={renderLocale}
        disabled={disabled}
      />
    </div>
  );
};

export default LocaleSwitcher;
